import type { ViewMode } from '../../game/view';
import { istTouchGeraet } from '../../lib/eingabeart';

/**
 * Womit man benutzt: Auf dem Handy tippt man, in der Ego-Ansicht drueckt
 * man die Leertaste (E dreht dort den Blick), in der Draufsicht E.
 */
export function benutzenTaste(mode: ViewMode, touch = istTouchGeraet()): string {
  if (touch) return 'Tippen';
  return mode === '3d' ? 'Leertaste' : 'E';
}
